import { useState } from "react";
import { CheckIcon } from "../../../../../assets/icons";
import styles from "../unit-threshold-setup.module.scss";

interface NumberInputRowProps {
	label?: string;
	value: number | null;
	unit?: string;
	currencyPrefix?: string;
	step?: number;
	isSaved: boolean;
	isSaving?: boolean;
	canSave: boolean;
	onChange: (val: number) => void;
	onSave: () => void;
	plusMinus: boolean;
}

export const NumberInputRow = ({
	label,
	value,
	unit,
	currencyPrefix,
	step = 1,
	isSaved,
	isSaving,
	canSave,
	onChange,
	onSave,
	plusMinus
}: NumberInputRowProps) => {
	const [inputStr, setInputStr] = useState(value != null ? String(value) : "");

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const raw = e.target.value;
		if (/^\d*\.?\d*$/.test(raw)) {
			setInputStr(raw);
			const parsed = parseFloat(raw);
			if (!isNaN(parsed)) onChange(parsed);
			else if (raw === "") onChange(0);
		}
	};

	const handleBlur = () => {
		const parsed = parseFloat(inputStr);
		if (isNaN(parsed)) {
			setInputStr("0");
			onChange(0);
		}
	};

	const handleDecrement = () => {
		const current = value ?? 0;
		const next = Math.max(0, current - step);
		setInputStr(String(next));
		onChange(next);
	};

	const handleIncrement = () => {
		const current = value ?? 0;
		const next = current + step;
		setInputStr(String(next));
		onChange(next);
	};

	return (
		<div className={styles.numberInputRow}>
			{label && <span className={styles.inputLabel}>{label}</span>}
			<div className={styles.inputControls}>
				<div className={styles.textFieldWrapper}>
					{currencyPrefix && <span className={styles.currencyPrefix}>{currencyPrefix}</span>}
					<input
						className={styles.textField}
						type="text"
						inputMode="decimal"
						value={inputStr}
						onChange={handleInputChange}
						onBlur={handleBlur}
					/>
					{unit && <span className={styles.unitSuffix}>{unit}</span>}
				</div>
				{
					plusMinus &&
				
				<div className={styles.plusMinusGroup}>
					<button className={styles.plusMinusBtn} onClick={handleDecrement} disabled={(value ?? 0) <= 0}>
						<span>−</span>
					</button>
					<div className={styles.plusMinusDivider} />
					<button className={styles.plusMinusBtn} onClick={handleIncrement}>
						<span>+</span>
					</button>
				</div>
				}
				<button
					className={`${styles.saveButton} ${!canSave ? styles.saveButtonDisabled : ""} ${isSaved ? styles.saveButtonSaved : ""}`}
					onClick={onSave}
					disabled={!canSave || isSaving}
				>
					{isSaving ? (
						<span className={styles.saveSpinner} />
					) : isSaved ? (
						<>
							<CheckIcon width={16} height={16} />
							<span className={styles.saveButtonLabel}>Saved</span>
						</>
					) : (
						<span className={styles.saveButtonLabel}>Save</span>
					)}
				</button>
			</div>
		</div>
	);
};
